import { render, staticRenderFns } from "./SfProductCard.vue?vue&type=template&id=7c05f3d9"
import script from "./SfProductCard.vue?vue&type=script&lang=js"
export * from "./SfProductCard.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfProductCard.vue?vue&type=style&index=0&id=7c05f3d9&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "7935e980"
  
)

export default component.exports